<template>
  <v-app id="inspire" class="signin-container" :style="backgroundStyle">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Havet admin</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                    label="Mejladress"
                    type="text"
                    v-model="email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Lösenord"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submit" :loading="loading">Logga in</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-snackbar v-model="errorWhileSigningIn.hasError" :timeout="errorWhileSigningIn.timeout">
      {{ errorWhileSigningIn.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="errorWhileSigningIn.hasError = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import backgroundImage from '@/assets/bg.jpg'

export default {
  data() {
    return {
      errorWhileSigningIn: {
        hasError: false,
        message: '',
        timeout: 2000,
      },
      loading: false,
      valid: false,
      e1: false,
      password: '',
      passwordRules: [(v) => !!v || 'Password is required'],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  computed: {
    backgroundStyle() {
      return `background-image:url('${backgroundImage}')`
    },
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true
          await this.$store.dispatch('auth/authenticate', {
            user: this.email,
            password: this.password,
          })
          this.$router.push({ name: 'Start' })
        } catch ({ message }) {
          this.errorWhileSigningIn.message = message
          this.errorWhileSigningIn.hasError = true
        } finally {
          this.loading = false
        }
      }
    },
    clear() {
      this.$refs.form.reset()
    },
  },
}
</script>

<style lang="less" scoped>
.signin-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
</style>
